module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/lilly-scoutelas-b2623060ce84aa1d7047302862b1d8c3.jpg";